export enum CodeViolationTypeEnum {
    WARNING = 'WARNING',
    POINT = 'POINT',
    GAME = 'GAME',
    DEFAULT = 'DEFAULT'
}
